import { AppType } from "@/features/applications";
import { Form, InputNumber, Tag } from "antd";
import { FormInstance } from "antd/es/form";
import React from "react";

import { alertFormKeys } from "./constants";

interface IProps {
  form: FormInstance;
  ticker: string;
  exchange: string;
  selectedLimit: AppType.AlertLimits[];
}
export default ({ form, ticker, exchange, selectedLimit }: IProps) => {
  const filteredLimit = selectedLimit.find(e => e.ticker === ticker && e.exchange === exchange);

  return (
    <>
      <Form layout="inline" form={form}>
        <Form.Item>
          <Tag color="red">Alert Limits:</Tag>
        </Form.Item>
        <Form.Item
          help="Upper limit"
          name={`${alertFormKeys.alertUpper}-${ticker}-${exchange}`}
          initialValue={filteredLimit && filteredLimit.upperAlert}
        >
          <InputNumber style={{ width: 200 }} formatter={value => `$ ${value}`} placeholder="Upper Limit" />
        </Form.Item>
        <Form.Item
          help="Lower Limit"
          name={`${alertFormKeys.alertLower}-${ticker}-${exchange}`}
          initialValue={filteredLimit && filteredLimit.lowerAlert}
        >
          <InputNumber style={{ width: 200 }} formatter={value => `$ ${value}`} placeholder="Lower Limit" />
        </Form.Item>
      </Form>
      <Form layout="inline" form={form}>
        <Form.Item>
          <Tag color="orange">Warning Limits:</Tag>
        </Form.Item>
        <Form.Item
          help="Upper limit"
          name={`${alertFormKeys.warningUpper}-${ticker}-${exchange}`}
          initialValue={filteredLimit && filteredLimit.upperWarning}
        >
          <InputNumber style={{ width: 200 }} formatter={value => `$ ${value}`} placeholder="Upper Limit" />
        </Form.Item>
        <Form.Item
          help="Lower Limit"
          name={`${alertFormKeys.warningLower}-${ticker}-${exchange}`}
          initialValue={filteredLimit && filteredLimit.lowerWarning}
        >
          <InputNumber style={{ width: 200 }} formatter={value => `$ ${value}`} placeholder="Lower Limit" />
        </Form.Item>
      </Form>
    </>
  );
};
